/** @format */

import { useEffect, useMemo, useState } from 'react';
import { Dialog } from '@mui/material';
import Page from 'src/components/Page';
import Breadcrumb from 'src/components/Breadcrumb';
import { WelcomeTitle, WidgetGrid } from 'src/components';
import { useDispatch, useSelector } from 'src/store';
import useAuth from 'src/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { getDashboard, getWidgetInfo } from 'src/slices/users';
import OnBoardingView from 'src/views/onboarding/OnBoardingView';
import { getAppLanguage } from 'src/utils/locale';
import { Button } from 'src/components/button';
import { useNavigate } from 'react-router-dom';

const MAX_DIALOG_WIDTH_PX = 1110;

const OnboardingPageView = () => {
  const { user } = useAuth();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { widgetInfo } = useSelector(state => state.users);
  const [open, setOpen] = useState(false);

  const lang = useMemo(() => getAppLanguage(), [i18n.language]);
  const isCompleted = Boolean(user?.onBoardingComplete);

  useEffect(() => {
    if (!user) return;
    // if (isCompleted) dispatch(getDashboard(HELP_DASHBOARD_ID, lang));
    // else dispatch(getWidgetInfo(lang));
    // dispatch(getWidgetInfo(lang));
  }, [dispatch, isCompleted, lang, user]);

  useEffect(() => {
    const widgetData = (widgetInfo as { data?: unknown[] })?.data;
    if (!open && widgetData && Array.isArray(widgetData) && widgetData.length > 0) {
      setOpen(true);
    }
  }, [open, widgetInfo]);

  const breadcrumbData = [
    {
      title: t('dashboard.title')
    }
  ];

  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    setOpen(false);
  };

  return (
    <Page className={`dashboard`} title={t('menu.help')}>
      <Breadcrumb data={breadcrumbData} />
      <div className="container">
        {isCompleted ? (
          <div style={{ marginTop: 16, marginBottom: 16 }}>
            <Button label={t('common.button.backbtn')} secondary borderOnly onClick={() => navigate(`/dashboard`)} />
          </div>
        ) : (
          <WelcomeTitle>
            {user && user.firstName && t('dashboard.welcome')} {user && user.firstName} {user && user.lastName}
            {user && user.firstName && '!'}
          </WelcomeTitle>
        )}
      </div>
      <WidgetGrid />

      <Dialog
        open={open}
        onClose={handleDialogClose}
        disableEscapeKeyDown
        maxWidth={false}
        PaperProps={{
          style: { borderRadius: 10, maxWidth: MAX_DIALOG_WIDTH_PX, width: '100%' }
        }}>
        <OnBoardingView onCloseModal={() => setOpen(false)} />
      </Dialog>
    </Page>
  );
};

export default OnboardingPageView;
